export default () => {
  const containers = document.querySelectorAll('.js-trigger-target');

  if (containers.length < 1) return;

  if (!('IntersectionObserver' in window)) {
    return;
  }

  [...containers].forEach(container => {
    let triggers = container.querySelectorAll('.js-trigger-target--trigger')
    let targets = container.querySelectorAll('.js-trigger-target--target')
    let dots = container.querySelectorAll('.js-trigger-target--dot')
    let sliderObserver = ''

    if (window.innerWidth < 768) {
      sliderObserver = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const name = entry.target.dataset.content;
              const target = container.querySelector(`[data-target="${name}"]`);
              const trigger = container.querySelector(`[data-content="${name}"]`);
              const dot = container.querySelector(`[data-index="${name}"]`);

              console.log(name);

              [...dots].forEach(item => {
                if (item !== dot) {
                  item.classList.remove('active');
                }
              });

              ;[...triggers].forEach(trigger => {
                if (trigger.classList.contains('active')) {
                  trigger.classList.remove('active')
                }
              })
            
              ;[...targets].forEach(target => {
                if (target.classList.contains('active')) {
                  target.classList.remove('active')
                }
              })

              target.classList.add('active');
              trigger.classList.add('active');
              // trigger.scrollIntoView({
              //   behavior: 'auto',
              //   block: 'center',
              //   inline: 'center'
              // })
              dot.classList.add('active');
            }
          });
        },
        { threshold: 0.8, root: container.querySelector('.c-static-three-layers__container') }, // Add 50%, add active
      );
    }

    ;[...triggers].forEach( trigger => {
      trigger.addEventListener('click', addActive)

      if (window.innerWidth < 768) {
        sliderObserver.observe(trigger);
      }
    })

    container.querySelector(`.js-trigger-target--target[data-target="descr_1"]`).classList.add('active');
    container.querySelector(`.js-trigger-target--trigger[data-content="descr_1"]`).classList.add('active');

    function addActive(e) {
      const clickedTrigger = e.currentTarget
      const name = clickedTrigger.dataset.content
      const matchingContent = container.querySelector(`.js-trigger-target--target[data-target=${name}]`)
      const matchingDot = container.querySelector(`.js-trigger-target--dot[data-index=${name}]`)

      if ( ! clickedTrigger.classList.contains('active') ) {
        closeAll()
        clickedTrigger.classList.add('active')
        matchingContent.classList.add('active')
        matchingDot.classList.add('active')
      }
    }

    function closeAll() {
      ;[...triggers].forEach(trigger => {
        if (trigger.classList.contains('active')) {
          trigger.classList.remove('active')
        }
      })
    
      ;[...targets].forEach(target => {
        if (target.classList.contains('active')) {
          target.classList.remove('active')
        }
      })

      ;[...dots].forEach(dot => {
        if (dot.classList.contains('active')) {
          dot.classList.remove('active')
        }
      })
    }
  })
};


// WEBPACK FOOTER //
// ./src/js/modules/TriggerTarget.js